import { GA_MEASUREMENT_ID } from "../config";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let initialized = false;

/** Whether analytics is configured for this environment. */
export const analyticsEnabled = Boolean(GA_MEASUREMENT_ID);

/**
 * Load the GA4 gtag script once and configure the property. Safe to call
 * multiple times — subsequent calls are no-ops. Does nothing when no
 * measurement ID is configured (e.g. local dev / previews).
 */
export function initAnalytics() {
  if (initialized || !analyticsEnabled) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // We send page_view manually on route changes for accurate SPA tracking.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

/** Record a single-page-app page view. */
export function trackPageView(path: string) {
  if (!analyticsEnabled || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Track a successful lead submission — the key business conversion. */
export function trackLead(pkg?: string) {
  if (!analyticsEnabled || !window.gtag) return;
  window.gtag("event", "generate_lead", {
    currency: "INR",
    package: pkg || "General Inquiry",
  });
}
